import React from 'react';
import PatientQueue from './PatientQueue';

const AllAPCMPatientsQueue = () =>
	<PatientQueue
		patientDetailColumn
		allAPCMProviderDetailColumn
		allAPCMPatientProgram
		apcmEngagement
		myPatientStatusColumn
		showScheduleCallFilter
		showRpmEligibilityFilter
		showFilters
		chartColumn
		lastWorkedByColumn
		page
		queue="allAPCMPatients"
		endpoint="APCM_All"
		label="All APCM Patients"
		showUrgentFilter
		rowHeight={170}
		hideAssignee
	/>;

export default AllAPCMPatientsQueue;
